export const practiceFrontQueryKeys = {
  practiceFront: ["practice-front"] as const,
  practiceFrontDomain: ["practice-front", "domain"] as const,
  practiceFrontByDomain: (domain: string) =>
    ["practice-front", "domain", domain] as const,
  practiceFrontByDomainAndPage: (domain: string, page?: string) =>
    ["practice-front", "domain", domain, "page", page] as const,
};
